<template>
  <div class="service-task-overview__container">
    <div class="service-task-overview__body">
      <div class="title-container">
        <v-icon small>mdi-wrench</v-icon>
        <BaseTypography variant="subtitle" style="flex-grow: 1">{{ serviceDetails.title }}</BaseTypography>
        <ContextMenu
          v-if="readonly ? false : isRemoveOptionVisible"
          :buttons="[
            {
              title: 'Usuń usługę',
              command: this.removeServiceItemCommand(service),
            },
          ]"
        />
      </div>

      <DescriptionSection>
        <component :is="serviceDetails.details" :service="service" />
      </DescriptionSection>
    </div>
    <div class="service-task-overview__footer" v-if="!readonly">
      <BaseTextButton prependIcon="mdi-pencil" @click="$emit('edit', service)">Edytuj</BaseTextButton>
    </div>
  </div>
</template>

<script>
import BaseTextButton from '@/component/Base/base-text-button';
import BaseTypography from '@/component/Base/base-typography';
import DescriptionSection from '@/component/Description/description-section';
import DescriptionItem from '@/component/Description/description-item';
import ContextMenu from '@/component/ContextMenu/context-menu';
import { SERVICE_TYPE_DICT } from '@/core/dict/service-type-dict';
import SupplementingMaterialsDetails from './supplementing-materials-details';
import RollingStockServiceDetails from './rolling-stock-service-details';
import LocomotiveWashingDetails from './locomotive-washing-details';
import LocomotiveControlReviewDetails from './locomotive-control-review-details';
import TrainCleaningDetails from './train-cleaning-details';
import CargoCorrectionDetails from './cargo-correction-details';

export default {
  name: 'ServiceTaskOverviewCard',
  components: {
    BaseTextButton,
    BaseTypography,
    DescriptionSection,
    DescriptionItem,
    ContextMenu,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
    isRemoveOptionVisible: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    serviceDetails() {
      switch (this.service.serviceType) {
        case SERVICE_TYPE_DICT.SUPPLEMENTING_MATERIALS:
          return {
            title: 'Uzupełnienie materiałów eksploatacyjnych',
            details: SupplementingMaterialsDetails,
          };
        case SERVICE_TYPE_DICT.FLEET_SERVICE:
          return {
            title: 'Serwis taboru',
            details: RollingStockServiceDetails,
          };
        case SERVICE_TYPE_DICT.LOCOMOTIVE_WASHING:
          return {
            title: 'Mycie lokomotywy',
            details: LocomotiveWashingDetails,
          };
        case SERVICE_TYPE_DICT.REVIEW_P1:
          return {
            title: 'Przegląd lokomotywy (P1)',
            details: LocomotiveControlReviewDetails,
          };
        case SERVICE_TYPE_DICT.REVIEW_P2:
          return {
            title: 'Przegląd lokomotywy (P2)',
            details: LocomotiveControlReviewDetails,
          };
        case SERVICE_TYPE_DICT.REVIEW_P3:
          return {
            title: 'Przegląd lokomotywy (P3)',
            details: LocomotiveControlReviewDetails,
          };
        case SERVICE_TYPE_DICT.TRAIN_CLEANING:
          return {
            title: 'Sprzątanie składu',
            details: TrainCleaningDetails,
          };
        case SERVICE_TYPE_DICT.CARGO_CORRECTION:
          return {
            title: 'Korekta ładunku',
            details: CargoCorrectionDetails,
          };
        default:
          return {};
      }
    },
  },
  methods: {
    removeServiceItemCommand(service) {
      return {
        execute: () => {
          this.$emit('removeServiceItem', service);
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.service-task-overview {
  &__container {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    box-shadow: 0px 3px 5px -2px rgba(0, 0, 0, 0.2), 0px 2px 3px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
  }

  &__body {
    flex-grow: 1;
    padding: 8px 16px 52px 16px;

    .title-container {
      display: flex;
      align-items: center;
      padding: 8px 0px;
      gap: 8px;
    }
  }

  &__footer {
    display: flex;
    height: 52px;
    flex-direction: row;
    align-items: center;
    padding: 8px 16px;
    gap: 8px;

    border-top: 1px solid #e0e0e0;
  }
}
</style>
